export type WalletRequestStep = 1 | 2 | "created";

/**
 * `?step=` for /wallets/new. The flow has two steps (ALL-4839); legacy deep
 * links to the removed steps 3/4 and "confirm" land on the review step, which
 * itself falls back to details until a valid name has been entered.
 */
export function resolveWalletRequestStep(raw: string | undefined): WalletRequestStep {
  if (raw === "created") return raw;
  if (raw === "confirm") return 2;
  const n = Number(raw);
  return n >= 2 && n <= 4 ? 2 : 1;
}
